export const commonTypes = {
  GET_EXCEPTION_TYPES_LOADING: 'GET_EXCEPTION_TYPES_LOADING',
  GET_EXCEPTION_TYPES_SUCCESS: 'GET_EXCEPTION_TYPES_SUCCESS',
  GET_EXCEPTION_TYPES_FAILURE: 'GET_EXCEPTION_TYPES_FAILURE'
};
